import type { PropsWithChildren } from 'react'
import { createContext, useContext, useMemo, useState } from 'react'

export interface InMemoryBlobContextValue {
  setBlob: (blob: File) => void
  getPlaybackUrl: () => string
}

export const InMemoryMotePlaybackLocationContext =
  createContext<InMemoryBlobContextValue>({
    setBlob: () => void 0,
    getPlaybackUrl: () => ''
  })

export interface InMemoryMotePlaybackLocationState {
  file: File | null
  objectURL: string
}

export function InMemoryMotePlaybackLocationProvider(props: PropsWithChildren) {
  const [state, setState] = useState<InMemoryMotePlaybackLocationState>({
    objectURL: '',
    file: null
  })

  const value = useMemo<InMemoryBlobContextValue>(
    () => ({
      setBlob: file => {
        setState({
          file,
          objectURL: URL.createObjectURL(file)
        })
      },
      getPlaybackUrl: () => state.objectURL
    }),
    [state]
  )

  return (
    <InMemoryMotePlaybackLocationContext.Provider value={value}>
      {props.children}
    </InMemoryMotePlaybackLocationContext.Provider>
  )
}

export function useInMemoryPlaybackLocationContext() {
  return useContext(InMemoryMotePlaybackLocationContext)
}
